import React, { ReactElement } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import SlickSlider from 'react-slick';

type props = {
  settings: Object
  children: ReactElement | JSX.Element[]
};
export default function Slider(props: Readonly<props>): ReactElement {
  return (
    <SlickSlider {...props.settings}>
    </SlickSlider>
  );
}
